import api from './api';

export interface IOfferDashboardOffer {
  created: string;
  customerName: null | string;
  departmentId: null | number;
  departmentName: null | string;
  // An opportunity: the sum of its estimated rows
  estimate: null | number;
  expense: null | number;
  id: number;
  // NDA protected and the user is outside of the NDA: the name and sums are hidden
  ndaRestricted: boolean;
  revisionNumber: number;
  sentAt: null | string;
  status: string;
  targetName: string;
  type: string;
  value: null | number;
}

export interface IOfferDashboard {
  // The start of the period
  from: string;
  // The end of the period, not included
  to: null | string;
  // The sums of the positions of each offer by work type
  groups: { expense: number; group: string; offerId: number; value: number }[];
  offers: IOfferDashboardOffer[];
}

// One visit to an offer or a position: who, when, for how long and whether saved
export interface IOfferLogEntry {
  // A position was open for calculating, not only for looking
  calculated: boolean;
  department: null | string;
  // A status change: the status before it and the new one
  fromStatus: null | string;
  toStatus: null | string;
  // Unique in the list
  key: string;
  // visit = the offer or a position was open, status = the status was changed
  kind: 'visit' | 'status';
  offerId: number;
  offerType: string;
  openedAt: string;
  // The code and name of the position, null for the offer page
  position: null | string;
  savedAt: null | string;
  targetName: null | string;
  // When the page was closed or last reported itself
  until: string;
  user: string;
  visitId: number;
}

export interface IOfferLogPage {
  entries: IOfferLogEntry[];
  total: number;
}

export default {
  // The offers created during the period for the offer dashboard, the end not included
  getOfferDashboard: (from: Date, to: Date): Promise<IOfferDashboard> =>
    api.get('/api/v1/reports/offer-dashboard', {
      from: from.toISOString(),
      to: to.toISOString(),
    }),
  // The log of all offers, for the users with the right to read the log
  getOfferLog: (filters: {
    limit: number;
    offset: number;
    search?: string;
    since?: string;
  }): Promise<IOfferLogPage> => api.get('/api/v1/reports/offer-log', filters),
  // The history of one offer, for its maker and the log readers
  getOfferHistory: (
    id: number,
    isAdditionalOffer: boolean
  ): Promise<IOfferLogPage> =>
    api.get(
      isAdditionalOffer
        ? `/api/v1/additionaloffers/${id}/history`
        : `/api/v1/offers/${id}/history`
    ),
};
